<template>
    <el-container class="spfBody">
        <el-main>
            <el-tabs v-model="activeName_ysgs" :before-leave="moreState" class="ysxkgs_tabs">
                <el-tab-pane label="预售许可公示" name="first"  class="spfTabs">
                    <el-row :gutter="12" class="row-con">
                        <el-col :span="6" v-for="item in tableData" v-bind:key="item.id" class="xsphcard">
                            <el-card shadow="hover" @dblclick.native="showMoreXx_ysxk(item.id,item.permitno)">
                                <el-row class="spfysgs">
                                    <span class="xqmc">{{item.xmmc}}</span>
                                    <span class="fwcountCss">共<span class="fwcount">{{item.ts}}</span>套</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>开发企业：</span>
                                    <span>{{item.kfqy}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>证号：</span>
                                    <span>{{item.permitno}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>资金监管银行：</span>
                                    <span>{{item.jgyh}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>银行账户：</span>
                                    <span>{{item.yhzh}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>发证日期：</span>
                                    <span>{{item.fzrq}}</span>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="现售备案公示" name="second">
                    <el-row :gutter="12" class="row-con">
                        <el-col :span="6" v-for="item in tableData3" v-bind:key="item.id" class="xsphcard">
                            <el-card shadow="hover" @dblclick.native="showMoreXx_xsba(item.id,item.permitno)">
                                <el-row class="spfysgs">
                                    <span class="xqmc">{{item.xmmc}}</span>
                                    <span class="fwcountCss">共<span class="fwcount">{{item.ts}}</span>套</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>开发企业：</span>
                                    <span>{{item.kfqy}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>证号：</span>
                                    <span>{{item.bdcqzh}}</span>
                                </el-row>
                                <el-row class="spfysgsfw">
                                    <span>发证日期：</span>
                                    <span>{{item.fzrq}}</span>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane name="more" class="more-btn" ><span slot="label" @click="showMore">查看更多＞</span></el-tab-pane>
            </el-tabs>

            <!--<el-tabs class="xsphTabs" v-model="activeName2" @tab-click="handleClick2" :before-leave="moreState">
                <el-tab-pane label="今日销售排行" name="first">
                    <el-row :gutter="12">
                        <el-col :span="6" v-for="(item,index) in tableData2" class="xsphcard">
                            <el-card shadow="hover" class="xsph">
                                <el-row class="imgCard">
                                    <div class="xsphZong">
                                        <div :class='[index >2 ?"class1":"class2","xsphbCount"]'></div>
                                        <span class="spfPhNum">{{index+1}}</span>
                                    </div>
                                    <img  :src="item.imgUrl" class="image" style="width: 100%"/>
                                </el-row>
                                <div class="textCard">
                                    <el-row >
                                        <span>销售套数：<span class="fwcount2">{{item.xsts}}</span>套</span>
                                    </el-row>
                                    <el-row>
                                        <span>销售面积：{{item.xsmj}}</span>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="本周销售排行" name="second">
                    <el-row :gutter="12">
                        <el-col :span="6" v-for="(item,index) in tableData2" class="xsphcard">
                            <el-card shadow="hover" class="xsph">
                                <el-row class="imgCard">
                                    <div class="xsphZong">
                                        <div :class='[index >2 ?"class1":"class2","xsphbCount"]'></div>
                                        <span class="spfPhNum">{{index+1}}</span>
                                    </div>
                                    <img  :src="item.imgUrl" class="image" style="width: 100%"/>
                                </el-row>
                                <div class="textCard">
                                    <el-row >
                                        <span>销售套数：<span class="fwcount2">{{item.xsts}}</span>套</span>
                                    </el-row>
                                    <el-row>
                                        <span>销售面积：{{item.xsmj}}</span>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="本月销售排行" name="third">
                    <el-row :gutter="12">
                        <el-col :span="6" v-for="(item,index) in tableData4" class="xsphcard">
                            <el-card shadow="hover" class="xsph">
                                <el-row class="imgCard">
                                    <div class="xsphZong">
                                        <div :class='[index >2 ?"class1":"class2","xsphbCount"]'></div>
                                        <span class="spfPhNum">{{index+1}}</span>
                                    </div>
                                    <img  :src="item.imgUrl" class="image" style="width: 100%"/>
                                </el-row>
                                <div class="textCard">
                                    <el-row >
                                        <span>销售套数：<span class="fwcount2">{{item.xsts}}</span>套</span>
                                    </el-row>
                                    <el-row>
                                        <span>销售面积：{{item.xsmj}}</span>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane name="more" class="more-btn" ><span slot="label"><router-link to="/ywhome/spfhome">查看更多＞</router-link></span></el-tab-pane>
            </el-tabs>-->
        </el-main>
        <el-header class="headTop">
            <el-col :span="10" class="headDiv leftImg"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
            <el-col :span="4" class="headDiv"><div class="phValue">上市行情</div></el-col>
            <el-col :span="10" class="headDiv rightImg"><el-image  :src="require('../img2/clf/0031.png')" ></el-image></el-col>
        </el-header>
        <el-main>
            <el-table
                    :data="tableData5"
                    style="width: 100%"
                    :header-cell-class-name="ClassName_Biaotou1"
                    :cell-class-name="tableRowClassName_tableLieSszhq"
                    :row-class-name="tableRowClassName">
				<el-table-column label="" header-align="center">
                    <el-table-column
                            header-align="center"
                            prop="dataname"
                            label="-"
                            align="center"
                            width="200">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="上市总行情" header-align="center">
                    <el-table-column
                            header-align="center"
                            prop="zts"
                            label="套数"
                            align="center"
                            >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="zmj"
                            label="面积/㎡"
                            align="center">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="住宅上市行情" header-align="center">
                    <el-table-column
                            header-align="center"
                            prop="zzts"
                            label="套数"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="zzmj"
                            label="面积/㎡"
                            align="center">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="商业上市行情" header-align="center">
                    <el-table-column
                            header-align="center"
                            prop="syts"
                            label="套数"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="symj"
                            label="面积/㎡"
                            align="center">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="其他上市行情" header-align="center">
                    <el-table-column
                            header-align="center"
                            prop="qtts"
                            label="套数"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="qtmj"
                            label="面积/㎡"
                            align="center">
                    </el-table-column>
                </el-table-column>
            </el-table>

            <!--成交行情-->
            <el-tabs v-model="SpfCjhqactiveName" :before-leave="moreState" class="spfcjhqTop">
                <el-tab-pane label="商品房成交行情" name="SpfCjhqfirst"  class="spfTabs">
                    <el-table
                            :data="tableData_spfcjhq"
                            border
                            :span-method="objectSpanMethod"
                            :header-cell-class-name="ClassName_Biaotou"
                            :cell-class-name="tableRowClassName_tableLie"
                            style="width: 100%; margin-top: 20px">
                        <el-table-column
                                prop="dataname"
                                label=""
                                align="center"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="type"
                                align="center"
                                label="类型">
                        </el-table-column>
                        <el-table-column
                                prop="amount"
                                align="center"
                                label="总计">
                        </el-table-column>
                        <el-table-column
                                prop="amount_zz"
                                align="center"
                                label="住宅">
                        </el-table-column>
                        <el-table-column
                                prop="amount_sy"
                                align="center"
                                label="商业">
                        </el-table-column>
                        <el-table-column
                                prop="amount_qt"
                                align="center"
                                label="其他">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="存量房成交行情" name="SpfCjhqsecond">
                    <el-table
                            :data="tableData_clfcjhq"
                            border
                            :span-method="objectSpanMethod"
                            :header-cell-class-name="ClassName_Biaotou"
                            :cell-class-name="tableRowClassName_tableLie"
                            style="width: 100%; margin-top: 20px">
                        <el-table-column
                                prop="dataname"
                                label=""
                                align="center"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="type"
                                align="center"
                                label="类型">
                        </el-table-column>
                        <el-table-column
                                prop="amount"
                                align="center"
                                label="总计">
                        </el-table-column>
                        <el-table-column
                                prop="amount_zz"
                                align="center"
                                label="住宅">
                        </el-table-column>
                        <el-table-column
                                prop="amount_sy"
                                align="center"
                                label="商业">
                        </el-table-column>
                        <el-table-column
                                prop="amount_qt"
                                align="center"
                                label="其他">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <div class="spfcjhqTop">
                <el-tabs v-model="activeName" :before-leave="moreState" >
                    <el-tab-pane label="近30天商品房成交行情" name="first" lazy>
                        <spf_echats ref="myChart"></spf_echats>
                    </el-tab-pane>
                    <el-tab-pane label="近30天存量房成交行情" name="second" lazy>
                        <clf_echats></clf_echats>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!--<el-tabs v-model="xsph_activeName">
                <el-tab-pane label="商品房销售排行" name="first" >
                    <el-tab-pane label="按销售套数排行" name="first">
                        <el-table
                                :data="tableData_spfxsph"
                                style="width: 100%"
                                :header-cell-style="getRowClass"
                                :row-class-name="tableRowClassName">
                            <el-table-column
                                    header-align="center"
                                    label="排名"
                                    type="index"
                                    width="60"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="mjmc"
                                    label="募集名称"
                                    width="110"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="cjts"
                                    label="成交套数"
                                    width="80"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="bmts"
                                    width="80"
                                    align="center"
                                    label="表面套数">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="xsl"
                                    width="60"
                                    align="center"
                                    label="显示率"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    label="排名"
                                    type="index"
                                    width="60"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="mjmc"
                                    label="募集名称"
                                    width="110"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="cjts"
                                    label="成交套数"
                                    width="80"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="bmts"
                                    width="80"
                                    align="center"
                                    label="表面套数">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="xsl"
                                    width="60"
                                    align="center"
                                    label="显示率"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    label="排名"
                                    type="index"
                                    width="60"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="mjmc"
                                    label="募集名称"
                                    width="110"
                                    align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="cjts"
                                    label="成交套数"
                                    width="80"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="bmts"
                                    width="80"
                                    align="center"
                                    label="表面套数">
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    prop="xsl"
                                    width="60"
                                    align="center"
                                    label="显示率"
                            >
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="按销售面积排行" name="second">
                        销售面积排行
                    </el-tab-pane>
                </el-tab-pane>
                <el-tabs v-model="xsph_activeName">
                </el-tabs>
                <el-tab-pane label="中介签约排行" name="second">
                    <clf_echats></clf_echats>
                </el-tab-pane>
            </el-tabs>-->
            <div class="spfcjhqTop">
                <el-tabs v-model="xsph_activeName" @tab-click="handleClick">
                    <el-tab-pane label="商品房销售排行" name="xsph_first">
                        <el-tabs v-model="tsmj_activeName" @tab-click="handleClick">
                                <el-table
                                        :data="tableData_spfxsph"
                                        style="width: 100%"
                                        class="xsph_tabs"
                                        :row-style="{height: '70px'}"
                                        :header-cell-class-name="ClassName_phBiaotou"
                                        :cell-class-name="classname_hang1"
                                        :row-class-name="tableRowClassName">
                                    <el-table-column label="今日排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcd" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcd">
                                                <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="xmmcd"
                                                label="项目名称"
                                                width="100"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsd"
                                                label="成交套数"
                                                width="80"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjd"
                                                width="80"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjed"
                                                width="80"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column label="本月排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcm" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcm">
                                            <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                        </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="xmmcm"
                                                label="项目名称"
                                                width="100"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsm"
                                                label="成交套数"
                                                width="80"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjm"
                                                width="80"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjem"
                                                width="80"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column label="本年排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcy" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcy">
                                            <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                        </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="xmmcy"
                                                label="项目名称"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsy"
                                                label="成交套数"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjy"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjey"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                </el-table>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="中介签约排行" name="xsph_second">
                        <el-tabs v-model="tsmj_activeName" @tab-click="handleClick">
                                <el-table
                                        :data="tableData_zjqyph"
                                        style="width: 100%"
                                        class="xsph_tabs"
                                        :row-style="{height: '70px'}"
                                        :header-cell-class-name="ClassName_phBiaotou"
                                        :cell-class-name="classname_hang1"
                                        :row-class-name="tableRowClassName">
                                    <el-table-column label="今日排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcd" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcd">
                                                <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                            </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="zjmcd"
                                                label="中介名称"
                                                width="100"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsd"
                                                label="成交套数"
                                                width="80"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjd"
                                                width="80"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjed"
                                                width="80"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column label="本月排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcm" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcm">
                                                <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                            </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="zjmcm"
                                                label="中介名称"
                                                width="100"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsm"
                                                label="成交套数"
                                                width="80"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjm"
                                                width="80"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjem"
                                                width="80"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column label="本年排行" header-align="center">
                                        <el-table-column
                                                header-align="center"
                                                label="排名"
                                                width="60"
                                                style="height: 180px"
                                                align="center"
                                        >
                                            <template slot-scope="scope">
                                                <img v-if="[scope.$index]<3&&scope.row.xmmcy" :src="scope.row.img" alt="">
                                                <span v-if="[scope.$index]>2&&scope.row.xmmcy">
                                                <span v-if="[scope.$index]>2&&[scope.$index]<9">0</span>{{scope.$index+1}}
                                            </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="zjmcy"
                                                label="中介名称"
                                                width="100"
                                                align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="cjtsy"
                                                label="成交套数"
                                                align="center">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjmjy"
                                                align="center"
                                                label="成交面积">
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                prop="cjjey"
                                                align="center"
                                                label="成交金额"
                                        >
                                        </el-table-column>
                                    </el-table-column>
                                </el-table>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import spf_echats from "../mainhtml/spf_echats";
    import clf_echats from "../mainhtml/clf_echats";
	import axios from 'axios';
    import * as echarts from 'echarts';
	import config from "@/config";
	const base_url = config.baseUrl + 'spf/';

    export default {
        name: "spf_home",
        components: {spf_echats,clf_echats},
        data() {
            const item = {
                xqmc: '颐和府',
                fwcount: '1223',
                address: '玄武区中山东路301号',
                fwno:'202040034W',
                bank:'中国农业银行',
                yhzh:'63483894930490',
            };
            const item2 = {
                xqmc: '颐和府',
                xsts: '93',
                xsmj: '1906.46',
                imgUrl: require("../img2/spf2/yhf2.png"),
            };
            const item3 = {
                xqmc: '顺华府',
                fwcount: '2223',
                address: '玄武区中山东路302号',
                fwno:'202040034W',
                bank:'中国农业银行',
                yhzh:'63483894930490',
            };
            const item4 = {
                xqmc: '顺化府',
                xsts: '83',
                xsmj: '1906.46',
                imgUrl: require("../img2/spf2/yhf2.png"),
            };
            const item5 = {
                zts_by:'844',
                zmj_by:'187682.32',
                zzts_by:'844',
                zzmj_by:'18233.34',
                syts_by:'833',
                ssmj_by:'18273.23',
                qtts_by:'333',
                qtmj_by:'18278.34'
            };
            // const item6 ={
            //     img:require('../img2/spf2/no1.png'),
            //     mjmc:'碧桂园一期',
            //     cjts:'4',
            //     bmts:'4',
            //     xsl:'0%',
            //     mjmc2:'碧桂园一期',
            //     cjts2:'4',
            //     bmts2:'4',
            //     xsl2:'0%',
            //     mjmc3:'碧桂园一期',
            //     cjts3:'4',
            //     bmts3:'4',
            //     xsl3:'0%',
            // };
            return {
                activeName_ysgs: 'first',
                activeName: 'first',
                SpfCjhqactiveName:'SpfCjhqfirst',
                activeName2: 'first',
                xsph_activeName:'xsph_first',
                tsmj_activeName:'tsmj_first',
                tableData: Array(8).fill(item),
                tableData2: Array(8).fill(item2),
                tableData3: Array(8).fill(item3),
                tableData4: Array(8).fill(item4),
                tableData_spfxsph: [
                    {
                        img:require('../img2/spf2/no1.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no2.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no3.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no3.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no3.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no3.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },
                    {
                        img:require('../img2/spf2/no3.png'),
                        xmmcd:'碧桂园一期',
                        cjtsd:'4',
                        cjmjd:'4',
                        cjjed:'0%',
                        xmmcm:'碧桂园一期',
                        cjtsm:'4',
                        cjmjm:'4',
                        cjjem:'0%',
                        xmmcy:'碧桂园一期',
                        cjtsy:'4',
                        cjmjy:'4',
                        cjjey:'0%',
                    },

                ],
                tableData_zjqyph: [],
				tableData5:[
                    {
                        datename:'本月',
                        zts:'844',
                        zmj:'187682.32',
                        zzts:'844',
                        zzmj:'18233.34',
                        syts:'833',
                        symj:'18273.23',
                        qtts:'333',
                        qtmj:'18278.34'
                    },
                    {
                        datename:'上月同期',
                        zts:'844',
                        zmj:'187682.32',
                        zzts:'844',
                        zzmj:'18233.34',
                        syts:'833',
                        symj:'18273.23',
                        qtts:'333',
                        qtmj:'18278.34'
                    },
                    {
                        datename:'本年',
                        zts:'844',
                        zmj:'187682.32',
                        zzts:'844',
                        zzmj:'18233.34',
                        syts:'833',
                        symj:'18273.23',
                        qtts:'333',
                        qtmj:'18278.34'
                    },
                    {
                        datename:'上年同期',
                        zts:'844',
                        zmj:'187682.32',
                        zzts:'844',
                        zzmj:'18233.34',
                        syts:'833',
                        symj:'18273.23',
                        qtts:'333',
                        qtmj:'18278.34'
                    },
                ],
                tableData_spfcjhq: [
					{
						dataname: '今天',
						type: '成交套数/套',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '今天',
						type: '成交面积/㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '今天',
						type: '成交均价/元-㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '本月',
						type: '成交套数/套',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					},{
						dataname: '本月',
						type: '成交面积/㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '本月',
						type: '成交均价/元-㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '本年',
						type: '成交套数/套',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					},{
						dataname: '本年',
						type: '成交面积/㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}, {
						dataname: '本年',
						type: '成交均价/元-㎡',
						amount: '844',
						amount_zz: '0',
						amount3: 0
					}
				],
				tableData_clfcjhq: [],
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                imgArray: [//图片路径
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                    require('../img2/clf/head3.png'),
                ],
            }
        },
        methods: {
            indexMethod(index) {
                if(index<1){
                    return true;
                }
                return false;
            },
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 ==0) {
                    return '';
                } else if (rowIndex%2 !=0) {
                    return 'success-row';
                }
                return '';
            },
            classname_hang1({row, column, rowIndex, columnIndex}){
                if(column==0){
                    if(rowIndex==0){
                        return 'class_hang1';
                    }else if(rowIndex==1){
                        return 'class_hang2';
                    }
                }
            },
            tableRowClassName_tableLie({row, column, rowIndex, columnIndex}) {
                if ( columnIndex==0) {
                    return 'table_firstLie0';
                }else if(columnIndex==1){
                    return 'table_firstLie1';
                }
                return '';
            },
            tableRowClassName_tableLieSszhq({row, column, rowIndex, columnIndex}) {
                if ( columnIndex==0) {
                    return 'table_firstLie0';
                }
                return '';
            },
            ClassName_Biaotou({row, column, rowIndex, columnIndex}) {
                if ( rowIndex==0 && columnIndex==0) {
                    return 'class_FirstBiaotou';
                }else if(rowIndex==0){
                    return 'class_Biaotou';
                }
            },
            ClassName_phBiaotou({row, column, rowIndex, columnIndex}) {
                if ( rowIndex==0) {
                    return 'class_Biaotou';
                }else{
                    return 'class_Biaotou2';
                }
            },
            ClassName_Biaotou1({row, column, rowIndex, columnIndex}) {
                if(rowIndex==0){
                    return 'class_Biaotou';
                }else{
                    return 'class_Biaotou1';
                }
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            showMore() {
                if(this.activeName_ysgs=="first"){
                    this.$router.push({path:'/ywhome/spfhome/ysxkshowmore',query:{ysxs:'ysxk'}})
                }else{
                    this.$router.push({path:'/ywhome/spfhome/ysxkshowmore',query:{ysxs:'xsba'}})
                }
            },
            handleClick_echarts(tab, event) {
                /*this.$nextTick(()=>{
                    alert(echarts.getInstanceByDom(this.$refs.myChart).length);
                    echarts.getInstanceByDom(this.$refs.myChart).resize();
                })*/
            },
            moreState(tab, event){
                if(tab == 'more'){
                    console.log("/////",tab, event );
                    return false;
                }
            },
            getRowClass ({ rowIndex }) {
                if (rowIndex == 0) {
                    return 'background:#F8F8F8'
                } else {
                    return ''
                }
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex % 3 === 0) {
                        return {
                            rowspan: 3,
                            colspan: 1
                        };
                    }else  if(rowIndex % 3 === 1){
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
			showMoreXx_ysxk(id, xkzh){
			    this.$router.push({path:'/ywhome/spfhome/ysxkshowmoreXx',query:{id:id,xssx:xkzh}})
			},
			showMoreXx_xsba(id, xkzh){
			    this.$router.push({path:'/ywhome/spfhome/xsbashowmoreXx',query:{id:id,xssx:xkzh}})
			}
        },
        mounted() {
			// 预售许可公示
			axios.get(base_url + "ysxkgs").then(response => this.tableData = response.data).catch(error => console.log(error, "error"));
			// 现售备案公示
			axios.get(base_url + "xsbags").then(response => this.tableData3 = response.data).catch(error => console.log(error, "error"));
			// 上市行情
			axios.get(base_url + "sshq").then(response => this.tableData5 = response.data).catch(error => console.log(error, "error"));
			// 商品房成交行情
			axios.get(base_url + "spfcjhq").then(response => this.tableData_spfcjhq = response.data).catch(error => console.log(error, "error"));
			// 存量房成交行情
			axios.get(base_url + "clfcjhq").then(response => this.tableData_clfcjhq = response.data).catch(error => console.log(error, "error"));
			// 排行
			axios.get(base_url + "spfxsph").then(response => {
				this.tableData_spfxsph = response.data.spfxsph;
				this.tableData_zjqyph = response.data.zjqyph;
				if (this.tableData_spfxsph[0]) this.tableData_spfxsph[0].img = require('../img2/spf2/no1.png');
				if (this.tableData_spfxsph[1]) this.tableData_spfxsph[1].img = require('../img2/spf2/no2.png');
				if (this.tableData_spfxsph[2]) this.tableData_spfxsph[2].img = require('../img2/spf2/no3.png');
				if (this.tableData_zjqyph[0]) this.tableData_zjqyph[0].img = require('../img2/spf2/no1.png');
				if (this.tableData_zjqyph[1]) this.tableData_zjqyph[1].img = require('../img2/spf2/no2.png');
				if (this.tableData_zjqyph[2]) this.tableData_zjqyph[2].img = require('../img2/spf2/no3.png');
			}).catch(error => console.log(error, "error"));
        },
    }
</script>
<style scoped>

</style>
<style>
     .el-tabs__content .el-tabs__active-bar {
        background-color: transparent !important;
    }
    .el-table td.is-center, .el-table th.is-center{
        text-align: center !important;
    }
    .el-table__header{
        width: 100% !important;
        table-layout: fixed;
    }
    .el-table__body {
        width: 100% !important;
    }
    .spfBody .headDiv{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-table .success-row {
        background: #f9fbfc;
    }
    /*设置表头样式*/
    .spfBody .class_Biaotou2{
        color: #5B5B5C;
        font-size: 14px;
    }
    .spfBody .class_Biaotou1{
        color: #5B5B5C;
        font-size: 16px;
    }
    .spfBody .class_Biaotou{
        background-color: #F3FAFF;
        color: #00448c;
        font-size: 18px;
    }
    /*设置右边框*/
    .spfBody .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: none;
    }
    .spfBody .table_firstLie{
        border-right:1px solid #EBEEF5 !important;
    }
    .spfBody .table_firstLie0{
        font-size: 14px;
        font-weight: 600;
    }
    .spfBody .table_firstLie1{
        font-size: 16px;
        font-weight: 600;
    }
    .spfBody .class_FirstBiaotou{
        border-right:1px solid #EBEEF5 !important;
        background-color: #F3FAFF;
    }
    .spfBody .xsph_tabs th:nth-child(5) div{
        border-right:3px solid  rgba(200,200,200,0.75);
    }
    .spfBody .xsph_tabs th:nth-child(10) div{
        border-right:3px solid  rgba(200,200,200,0.75);
    }

    /*tabs样式*/
    .el-tabs__nav-wrap::after {
        position: static !important;
    }
    .el-tabs__item{
        color: #666666;
        font-weight: bold;
    }
    .el-tabs__item.is-active {
        color: #00448C;
    }
    .el-tabs__item:hover {
        color: #00448C;
        cursor: pointer;
    }
    .el-tabs__active-bar{
        background-color: #00448C;
    }
    .spfBody .class1{
        display: none;
    }
    /*查看更多按钮*/
    .spfBody .ysxkgs_tabs .el-tabs__item.is-top:last-child{
        color: #888889;
    }
    .el-tabs__nav{
        float: none;
    }
    .spfBody .ysxkgs_tabs .el-tabs__item.is-top:last-child a{
        text-decoration: none;
        color: #888889;
    }
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    /*小卡片样式*/
    .spfTabs{
        line-height: 1.6;
    }
    .spfBody .el-card{
        line-height: 1.6;
    }
    .spfBody .fwcount{
        color: red;
        font-size: 1.5em;
        font-weight: 600;
    }
    .spfBody .fwcount2{
        color: red;
        font-size: 1.2em;
    }
    .fwcountCss{
        float: right;
        transform: translateY(-50%);
        margin-top: 1.2em;
    }
    .xqmc{
        font-size: 1.5em;
        font-weight: 600;
    }
    .spfBody .xsph .el-card__body{
        padding: 0;
    }
    .spfBody .textCard{
        padding: 20px;
    }
    .spfBody .xsphcard{
        margin-top: 20px;
    }
    .el-card{
        border: 1px solid #dcdcdc;
    }
    .spfBody .spfPhNum{
        margin-top: 3px;
        position: absolute;
        left: 50%;
        top: 40%;
        color: white;
        transform: translate(-50%, -50%);
    }
    .spfBody .xsphZong{
        position: absolute;
        display: inline-block;
        right: 0;
    }
    /*移动端样式*/
    @media screen and (max-width: 414px) {
        .spfBody .spfysgsfw{
            /*display: flex;
            flex-wrap: wrap;*/
        }
        .spfBody .el-main{
            padding: 0 14px;
        }
        .spfBody .ysxkgs_tabs .el-tabs__nav{
            display: flex;
            justify-content: space-between !important;
            transform: translateX(0px);
        }
        .spfBody .el-card__body{
            padding: 10px;
        }
        .spfBody .ysxkgs_tabs .el-tabs__item{
            padding: 0;
        }
        .jjjgDiv2{
            width:90%;
        }
        .el-tabs__item{
            font-size: 13px;
        }
        .NumFloat{
            text-align: left !important;
        }
        .el-main {
            font-size: 13px !important;
        }
        .el-table .cell{
            font-size: 13px !important;
        }

        .jjjgDiv img{
            width: 70%;
            height: auto;
        }
        .phbDivWidth2{
            margin-top: 10px;
        }
        .el-table td, .el-table th{
            padding: 9px 0;
        }
        .spfBody .el-col-6{
            width: 50%;
        }
        .spfBody .el-card__body{
            font-size: 11px;
        }
        .xsphTabs{
            margin-top: 20px;
        }
        .spfBody .leftImg{
            margin-right: 40px;
        }
        .spfBody .rightImg{
            margin-left: 40px;
        }
        .phValue{
            font-size: 13px;
            white-space: nowrap;
            color: #00448C;
            margin-top: -20px;
            font-weight:bolder;
            text-align: center;
        }
        .spfBody .headTop{
            margin-top: 20px;
            display: flex;
            height: 30px !important;
            align-items: center;
            align-content: center;
        }
        .spfBody .spfcjhqTop{
            margin-top: 10px;
        }
    }
    /*PC端样式*/
    @media screen and (min-width: 414px) {
        .spfBody{
            width: 82%;
            margin: auto;
        }
        .spfBody .ysxkgs_tabs .el-tabs__item.is-top:last-child{
            font-size: 13px;
        }
        .spfBody .el-tabs__item{
            font-size: 19px;
        }
        .spfBody .el-tabs--top .el-tabs__content .el-tabs__item{
            font-size: 14px !important;
        }
        .xsphTabs{
            margin-top: 40px;
        }
        /*查看更多按钮*/
        .spfBody .ysxkgs_tabs .el-tabs__item.is-top:last-child{
            font-size: 13px;
            float: right;
        }
        .spfBody .xsphcard{
            font-size: 14px;
        }
        .spfBody .rightImg2 .el-image{
            width: 100% !important;
        }
        .spfBody .leftImg2 .el-image{
            width: 100% !important;
        }
        .spfBody .rightImg .el-image{
            width: 100% !important;
        }
        .spfBody .leftImg .el-image{
            width: 100% !important;
        }
        .spfBody .phValue {
            font-size: 22px;
            color: #00448C;
            margin-top: -10px;
            font-weight:bolder;
            text-align: center;
        }
        .headTop{
            margin-top: 20px;
            display: flex;
            align-items: center;
            align-content: center;

        }
        .spfBody .spfcjhqTop{
            margin-top: 40px;
        }
    }

     /*.el-row  .el-card {
         min-width: 100%;
         height: 100%;
         margin-right: 20px;
         transition: all .5s;
     }*/

     .row-con {
         display: flex;
         flex-flow: row wrap;
     }
     .row-con .el-card {
         height: 100% !important;
     }
    .spfysgsfw span:first-child{
        font-weight: 600;
    }
</style>